(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhh-ce-sub-hub-below"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MQ = '(max-width: 767px)';
  var PREVIEW = 2;

  function blocks(copy) {
    var root = copy.querySelector('.metafield-rich_text_field') || copy;
    return Array.prototype.filter.call(root.children, function (el) {
      return el.nodeType === 1;
    });
  }

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function bind(section) {
    var copy = section.querySelector('[data-mhh-ce-learnt-copy]');
    var button = section.querySelector('[data-mhh-ce-learnt-more]');
    if (!copy || !button) return;
    var moreLabel = button.getAttribute('data-label-more') || 'Read more';
    var lessLabel = button.getAttribute('data-label-less') || 'Show less';
    var canCollapse = blocks(copy).length > PREVIEW;
    var expanded = false;

    function apply() {
      var mobile = isMobile();
      if (!canCollapse || !mobile) {
        copy.classList.remove('is-collapsed');
        button.hidden = true;
        button.setAttribute('aria-expanded', 'true');
        button.textContent = moreLabel;
        return;
      }
      button.hidden = false;
      if (expanded) {
        copy.classList.remove('is-collapsed');
        button.setAttribute('aria-expanded', 'true');
        button.textContent = lessLabel;
      } else {
        copy.classList.add('is-collapsed');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = moreLabel;
      }
    }

    button.addEventListener('click', function () {
      expanded = !expanded;
      apply();
    });

    window.addEventListener('resize', apply);
    apply();
  }

  function init() {
    document.querySelectorAll('[data-mhh-ce-learnt-disclosure]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
